import {
  Mark,
  mergeAttributes,
} from '@tiptap/core'

export interface PrintTrimOptions {
  HTMLAttributes: Record<string, any>,
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    printTrim: {
      /**
       * Set a printTrim mark
       */
      setPrintTrim: () => ReturnType,
      /**
       * Toggle a printTrim mark
       */
      togglePrintTrim: () => ReturnType,
      /**
       * Unset a printTrim mark
       */
      unsetPrintTrim: () => ReturnType,
    }
  }
}

export const starInputRegex = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))$/
export const starPasteRegex = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))/g
export const underscoreInputRegex = /(?:^|\s)((?:__)((?:[^__]+))(?:__))$/
export const underscorePasteRegex = /(?:^|\s)((?:__)((?:[^__]+))(?:__))/g

export const PrintTrim = Mark.create<PrintTrimOptions>({
  name: 'printTrim',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      //Ensure that the TN CMS page break class is added to the horizontal rule when it is present
      class: {
        default: 'print_trim',
        parseHTML: (element) => element.getAttribute('class'),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[class="print_trim"]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addCommands() {
    return {
      setPrintTrim: () => ({ commands }) => {
        return commands.setMark(this.name)
      },
      togglePrintTrim: () => ({ commands }) => {
        return commands.toggleMark(this.name)
      },
      unsetPrintTrim: () => ({ commands }) => {
        return commands.unsetMark(this.name)
      },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Enter': () => this.editor.chain().createParagraphNear().unsetPrintTrim().focus().run()
    }
  },
})